import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProviderCustomizeService } from 'src/app/services/provider-customize.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  standalone: false
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  showFooter$: Observable<boolean>;

  constructor(private providerCustomizeService: ProviderCustomizeService) {
    this.showFooter$ = this.providerCustomizeService.branding$
      .pipe(map((branding) => !branding.isResolving && !branding.isWhiteLabel));
  }
}
